<template>
  <div class="vant-table">
    <table cellspacing="0" :style="bgcolor" style="width:100%" class="table">
      <tr>
        <th class="th" v-for="(item, index) in option.column" :key="index">{{ item.label }}</th>
      </tr>
      <tr v-for="(item, index) in tableData" :key="index" class="list-tr">
        <td v-for="(context, i) in option.column" :key="i">{{ item[context.tableDataprop] }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  name: 'TableVant',
  props: {
    bgcolor: Object,
    tableData: Array,
    option: Object
  },
  watch: {
    bgcolor: {
      handler(val, oldVal) {
        this.bgcolor = val
      }
    },
    tableData: {
      handler(val, oldVal) {
        this.tableData = val
      }
    },
    option: {
      handler(val, oldVal) {
        this.option = val
      }
    }
  },
  created() {}
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
.vant-table{
  margin-top: 15px;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 120px;
  .table {
    border: 2px solid #ddd;
    line-height: 65px;
    font-size: 28px;
    text-align: center;
    color: #666;
    .th {
      // height: 1.074074rem;
      // line-height: 60px;
      // font-size: 30px;
      // text-align: center;
      min-width: 120px;
      // max-width: 120px;
      font-weight: 400;
      border-right: 2px solid #ddd;
    }
    .th:last-child {
      border-right: none;
    }
    .list-tr:hover {
      background-color: #f5f5f5;
    }
    // .list-tr:nth-child(2n) {
    //   background-color: #f6f6f6;
    // }
    td {
      // max-width: 120px;
      border-top: 2px solid #ddd;
      border-right: 2px solid #ddd;
    }
    td:last-child {
      border-right: none;
    }
  }
}
</style>
